<div class="signin-wrap">
  <section class="signin-box">
    <div class="signin-head text-center mb-3">
      <img class="img-fluid center-block" src="../../assets/images/logo_signin_smile9.png">
      <div><small class="version text-muted">{{VERSION}}</small></div>
    </div>
    <div class="signin-body">
      <ng-container *ngIf="!authServ.isLoading">
        <label class="signin-label">{{labelSigninId}}</label>
        <input id="signinId" name="signinId" class="col-12 text-left" type="text" [formControl]="signinId"
          (change)="signinId.setValue(validationServ.toHalfWidthAlphameric(signinId.value))"
          (change)="signinId.setValue(utilServ.uSmile9.validateUsernameStyle(signinId.value))">

        <label class="signin-label">{{labelPassword}}</label>
        <div class="password-wrap mb-4">
          <input id="password" name="password" class="w-100 text-left" [formControl]="password"
            [attr.type]="inputPasswordType" (keyup.enter)="clickSignin()"
            (change)="password.setValue(validationServ.toHalfWidthAlphameric(password.value))"
            (change)="password.setValue(utilServ.uType.checkAndTrim(password.value))">
          <span class="eye-style" [ngSwitch]="inputPasswordType">
            <span *ngSwitchCase="'password'" class="oi oi-eye text-muted" (click)="inputPasswordType = 'text';"></span>
            <span *ngSwitchCase="'text'" class="oi oi-eye text-danger" (click)="inputPasswordType = 'password';"></span>
          </span>
        </div>

        <button id="signin-btn" type="button" class="col-12 text-center btn btn-warning" (click)="clickSignin()">
          サインイン
        </button>
      </ng-container>
      <div *ngIf="authServ.isLoading" class="loading-area-sm">
        <app-loading [loadImgClass]="loadImgClass"></app-loading>
      </div>
    </div>
    <ng-container
      *ngIf="!authServ.mode.firstPassSettingMode && !authServ.mode.forgotPassMode && !authServ.mode.inputCodeMode">
      <div class="text-center text-muted mt-2 ml-3">
        <small>Powerd by S.K.S. Inc.</small>
      </div>
    </ng-container>

    <footer class="only-phone">
      <small>
        <a class="text-white" [href]="SKS_TERMS_OF_SERVICE" target="_blank" rel="noreferrer">サービス利用規約</a>
        <span> | </span>
        <a class="text-white" [href]="SKS_WEBSITE + 'privacy-policy2'" target="_blank" rel="noreferrer">プライバシーポリシー</a>
      </small>
    </footer>
  </section>

  <aside class="side-info">
    <div class="h-100 row align-items-center">
      <div class="title col-12">クラウド　社食・給食予約サービス Smile9へようこそ！</div>
      <div class="body col-12">
        <div class="description mb-3">
          登録済みの方は、左の入力フォームへ{{labelSigninId}}と{{labelPassword}}を入れ、サインインして下さい。<br>
          <small>※ここから「いただきます端末」などのカード認証はできません。</small>
        </div>
        <div class="detail-desc mb-3">
          Smile9は、社員食堂などの毎日のメニュー予約をスマホやPCから予約・キャンセル・変更できるクラウドサービスです。<br><br>
          詳しくは<a class="text-success" [href]="SKS_WEBSITE + 'service_smile9.html'" target="_blank"
            rel="noreferrer">運営会社サイト<span class="oi oi-share-boxed"></span></a>をご覧ください。<br>
          Smile9の無料デモ体験も提供しています
        </div>
        <div class="row detail-info mt-3">
          <div class="col-6">
            <div class="mini-header left">Smile9のご紹介</div>
            <div><a class="text-white" [href]="SKS_WEBSITE + 'archives/35'" target="_blank"
                rel="noreferrer">クラウド　社食・給食予約サービス Smile9</a></div>
            <div><a class="text-white" [href]="SKS_TERMS_OF_SERVICE" target="_blank" rel="noreferrer">サービス利用規約</a></div>
            <div><a class="text-white" [href]="SKS_WEBSITE + 'archives/528'" target="_blank" rel="noreferrer">推奨環境</a>
            </div>
          </div>
          <div class="col-6">
            <div class="mini-header right">運営会社</div>
            <div><a class="text-white" [href]="SKS_WEBSITE" target="_blank" rel="noreferrer">株式会社エス・ケイ・エス</a></div>
            <div><a class="text-white" [href]="SKS_WEBSITE + 'company.html'" target="_blank" rel="noreferrer">企業情報</a>
            </div>
            <div><a class="text-white" [href]="SKS_WEBSITE + 'privacy-policy2'" target="_blank"
                rel="noreferrer">プライバシーポリシー</a></div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</div>